var map = {
	"./Dashboard/Account/AccountEdit": [
		68685,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			528,
			8498,
			3968,
			8685
		]
	],
	"./Dashboard/Account/AccountEdit.js": [
		68685,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			528,
			8498,
			3968,
			8685
		]
	],
	"./Dashboard/Account/AccountList": [
		3341,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			4199,
			528,
			8498,
			3968,
			6865
		]
	],
	"./Dashboard/Account/AccountList.js": [
		3341,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			4199,
			528,
			8498,
			3968,
			6865
		]
	],
	"./Dashboard/Index/Home": [
		4710,
		9,
		[
			4710
		]
	],
	"./Dashboard/Index/Home.js": [
		4710,
		9,
		[
			4710
		]
	],
	"./Dashboard/Setting/CodeFirst": [
		58464,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			4937
		]
	],
	"./Dashboard/Setting/CodeFirst.js": [
		58464,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			4937
		]
	],
	"./Dashboard/Setting/CodeSecond": [
		524,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			6141
		]
	],
	"./Dashboard/Setting/CodeSecond.js": [
		524,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			6141
		]
	],
	"./Dashboard/Setting/ControlList": [
		6620,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			4333
		]
	],
	"./Dashboard/Setting/ControlList.js": [
		6620,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			4333
		]
	],
	"./Dashboard/Setting/CreateEnvironFirst": [
		93632,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			3632
		]
	],
	"./Dashboard/Setting/CreateEnvironFirst.js": [
		93632,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			3632
		]
	],
	"./Dashboard/Setting/CreateEnvironSecond": [
		3334,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			1414
		]
	],
	"./Dashboard/Setting/CreateEnvironSecond.js": [
		3334,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			1414
		]
	],
	"./Dashboard/Setting/CurrencySettingFirst": [
		73176,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			3176
		]
	],
	"./Dashboard/Setting/CurrencySettingFirst.js": [
		73176,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			3176
		]
	],
	"./Dashboard/Setting/CustomerCodeFirst": [
		11608,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			1608
		]
	],
	"./Dashboard/Setting/CustomerCodeFirst.js": [
		11608,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			1608
		]
	],
	"./Dashboard/Setting/CustomerCodeSecond": [
		74116,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			528,
			8498,
			4116
		]
	],
	"./Dashboard/Setting/CustomerCodeSecond.js": [
		74116,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			528,
			8498,
			4116
		]
	],
	"./Dashboard/Setting/GroupPagesFirst": [
		912,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			7785
		]
	],
	"./Dashboard/Setting/GroupPagesFirst.js": [
		912,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			7785
		]
	],
	"./Dashboard/Setting/GroupPagesSecond": [
		68444,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			3741
		]
	],
	"./Dashboard/Setting/GroupPagesSecond.js": [
		68444,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			3741
		]
	],
	"./Dashboard/Setting/SystemSetting": [
		47106,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			8851,
			7692,
			3743,
			6502,
			528,
			8498,
			3951
		]
	],
	"./Dashboard/Setting/SystemSetting.js": [
		47106,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			8851,
			7692,
			3743,
			6502,
			528,
			8498,
			3951
		]
	],
	"./Dashboard/Setting/SystemStyle": [
		35049,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			6502,
			2062,
			3213,
			7084,
			8498,
			3968,
			5049
		]
	],
	"./Dashboard/Setting/SystemStyle.js": [
		35049,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			6502,
			2062,
			3213,
			7084,
			8498,
			3968,
			5049
		]
	],
	"./Dashboard/Setting/TaxSettingFirst": [
		94566,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			4566
		]
	],
	"./Dashboard/Setting/TaxSettingFirst.js": [
		94566,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			4566
		]
	],
	"./Dashboard/Setting/UnitSettingFirst": [
		58633,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			4940
		]
	],
	"./Dashboard/Setting/UnitSettingFirst.js": [
		58633,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			528,
			8498,
			4940
		]
	],
	"./Dashboard/SysPermission/SysPermissionFirst": [
		49155,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			9155
		]
	],
	"./Dashboard/SysPermission/SysPermissionFirst.js": [
		49155,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			528,
			8498,
			9155
		]
	],
	"./Dashboard/SysPermission/SysPermissionSecond": [
		86917,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			3743,
			528,
			8498,
			5216
		]
	],
	"./Dashboard/SysPermission/SysPermissionSecond.js": [
		86917,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			3743,
			528,
			8498,
			5216
		]
	],
	"./Dashboard/UserDuty/UserDutyFirst": [
		30439,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			766
		]
	],
	"./Dashboard/UserDuty/UserDutyFirst.js": [
		30439,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			766
		]
	],
	"./Dashboard/UserDuty/UserDutySecond": [
		43601,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			3526,
			3743,
			8500,
			528,
			8498,
			3601
		]
	],
	"./Dashboard/UserDuty/UserDutySecond.js": [
		43601,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			3526,
			3743,
			8500,
			528,
			8498,
			3601
		]
	],
	"./Dashboard/UserLevel/UserLevelFirst": [
		18395,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2315,
			528,
			8498,
			3968,
			8395
		]
	],
	"./Dashboard/UserLevel/UserLevelFirst.js": [
		18395,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2315,
			528,
			8498,
			3968,
			8395
		]
	],
	"./Dashboard/UserLevel/UserLevelSecond": [
		27613,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			3526,
			3743,
			528,
			8498,
			3688
		]
	],
	"./Dashboard/UserLevel/UserLevelSecond.js": [
		27613,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			3526,
			3743,
			528,
			8498,
			3688
		]
	],
	"./Lite/BasicSetting/AccountEdit": [
		35486,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			528,
			8498,
			3968,
			8685,
			5486
		]
	],
	"./Lite/BasicSetting/AccountEdit.js": [
		35486,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7672,
			5485,
			528,
			8498,
			3968,
			8685,
			5486
		]
	],
	"./Lite/BasicSetting/AccountList": [
		83870,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			4199,
			528,
			8498,
			3968,
			9546
		]
	],
	"./Lite/BasicSetting/AccountList.js": [
		83870,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			4199,
			528,
			8498,
			3968,
			9546
		]
	],
	"./Lite/BasicSetting/CompanyFirst": [
		84394,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			4394
		]
	],
	"./Lite/BasicSetting/CompanyFirst.js": [
		84394,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			4394
		]
	],
	"./Lite/BasicSetting/CompanySecond": [
		54230,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			283,
			4230
		]
	],
	"./Lite/BasicSetting/CompanySecond.js": [
		54230,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			283,
			4230
		]
	],
	"./Lite/BasicSetting/LogisticsFirst": [
		83174,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			2127,
			3174
		]
	],
	"./Lite/BasicSetting/LogisticsFirst.js": [
		83174,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			2127,
			3174
		]
	],
	"./Lite/BasicSetting/LogisticsSecond": [
		87946,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			627,
			528,
			8498,
			1728,
			7946
		]
	],
	"./Lite/BasicSetting/LogisticsSecond.js": [
		87946,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			627,
			528,
			8498,
			1728,
			7946
		]
	],
	"./Lite/BasicSetting/PaymentFirst": [
		38077,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			6262,
			8077
		]
	],
	"./Lite/BasicSetting/PaymentFirst.js": [
		38077,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			6262,
			8077
		]
	],
	"./Lite/BasicSetting/SystemSetting": [
		58966,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			8851,
			7692,
			3743,
			6502,
			528,
			8498,
			1835
		]
	],
	"./Lite/BasicSetting/SystemSetting.js": [
		58966,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			8851,
			7692,
			3743,
			6502,
			528,
			8498,
			1835
		]
	],
	"./Lite/BasicSetting/WarehouseFirst": [
		99138,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9138
		]
	],
	"./Lite/BasicSetting/WarehouseFirst.js": [
		99138,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9138
		]
	],
	"./Lite/BasicSetting/WarehouseSecond": [
		9486,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			1451,
			9486
		]
	],
	"./Lite/BasicSetting/WarehouseSecond.js": [
		9486,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			1451,
			9486
		]
	],
	"./Lite/Commodity/CommodityListFirst": [
		61703,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2173,
			528,
			8498,
			3968,
			6801,
			8109,
			1703
		]
	],
	"./Lite/Commodity/CommodityListFirst.js": [
		61703,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2173,
			528,
			8498,
			3968,
			6801,
			8109,
			1703
		]
	],
	"./Lite/Commodity/CommodityListSecond": [
		29233,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			3743,
			1200,
			9109,
			528,
			8498,
			5959,
			9233
		]
	],
	"./Lite/Commodity/CommodityListSecond.js": [
		29233,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			3743,
			1200,
			9109,
			528,
			8498,
			5959,
			9233
		]
	],
	"./Lite/Commodity/CommoditySortFirst": [
		56715,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			7672,
			5485,
			9305,
			528,
			8498,
			4273,
			6715
		]
	],
	"./Lite/Commodity/CommoditySortFirst.js": [
		56715,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			7672,
			5485,
			9305,
			528,
			8498,
			4273,
			6715
		]
	],
	"./Lite/Commodity/StockPutInFirst": [
		8858,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			528,
			8498,
			340,
			8858
		]
	],
	"./Lite/Commodity/StockPutInFirst.js": [
		8858,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			528,
			8498,
			340,
			8858
		]
	],
	"./Lite/Commodity/StockPutInSecond": [
		42342,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			2342
		]
	],
	"./Lite/Commodity/StockPutInSecond.js": [
		42342,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			2342
		]
	],
	"./Lite/CustomerManagement/CustomerFirst": [
		9510,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			3394,
			9510
		]
	],
	"./Lite/CustomerManagement/CustomerFirst.js": [
		9510,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			3394,
			9510
		]
	],
	"./Lite/CustomerManagement/CustomerLevelFirst": [
		20222,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			2991,
			528,
			8498,
			222
		]
	],
	"./Lite/CustomerManagement/CustomerLevelFirst.js": [
		20222,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			2991,
			528,
			8498,
			222
		]
	],
	"./Lite/CustomerManagement/CustomerSecond": [
		50986,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			5093,
			986
		]
	],
	"./Lite/CustomerManagement/CustomerSecond.js": [
		50986,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			5093,
			986
		]
	],
	"./Lite/Index/Home": [
		18202,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2062,
			528,
			8498,
			3968,
			6801,
			7763,
			8202
		]
	],
	"./Lite/Index/Home.js": [
		18202,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2062,
			528,
			8498,
			3968,
			6801,
			7763,
			8202
		]
	],
	"./Lite/InventoryControl/InvAdjustFirst": [
		65962,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			8728,
			5962
		]
	],
	"./Lite/InventoryControl/InvAdjustFirst.js": [
		65962,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			8728,
			5962
		]
	],
	"./Lite/InventoryControl/InvAdjustSecond": [
		47894,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			7894
		]
	],
	"./Lite/InventoryControl/InvAdjustSecond.js": [
		47894,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			7894
		]
	],
	"./Lite/InventoryControl/StockListFirst": [
		6348,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			6348
		]
	],
	"./Lite/InventoryControl/StockListFirst.js": [
		6348,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			6348
		]
	],
	"./Lite/InventoryControl/StockListSecond": [
		80576,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6801,
			1499
		]
	],
	"./Lite/InventoryControl/StockListSecond.js": [
		80576,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6801,
			1499
		]
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst": [
		10763,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			7672,
			5485,
			5162,
			528,
			8498,
			3968,
			6801,
			5200,
			763
		]
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst.js": [
		10763,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			7672,
			5485,
			5162,
			528,
			8498,
			3968,
			6801,
			5200,
			763
		]
	],
	"./Lite/OrderManagement/OrderFirst": [
		97614,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2315,
			2425,
			1200,
			7672,
			5485,
			528,
			8498,
			3968,
			5932,
			7614
		]
	],
	"./Lite/OrderManagement/OrderFirst.js": [
		97614,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2315,
			2425,
			1200,
			7672,
			5485,
			528,
			8498,
			3968,
			5932,
			7614
		]
	],
	"./Lite/OrderManagement/OrderPickingFirst": [
		74861,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7041,
			528,
			8498,
			3968,
			3222,
			4861
		]
	],
	"./Lite/OrderManagement/OrderPickingFirst.js": [
		74861,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7041,
			528,
			8498,
			3968,
			3222,
			4861
		]
	],
	"./Lite/OrderManagement/OrderReturnFirst": [
		72500,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			9727
		]
	],
	"./Lite/OrderManagement/OrderReturnFirst.js": [
		72500,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			9727
		]
	],
	"./Lite/OrderManagement/OrderReturnSecond": [
		89544,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			2755,
			9544
		]
	],
	"./Lite/OrderManagement/OrderReturnSecond.js": [
		89544,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			2755,
			9544
		]
	],
	"./Lite/OrderManagement/OrderSecond": [
		1106,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			1200,
			528,
			8498,
			3968,
			909,
			1106
		]
	],
	"./Lite/OrderManagement/OrderSecond.js": [
		1106,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			1200,
			528,
			8498,
			3968,
			909,
			1106
		]
	],
	"./Lite/OrderManagement/OrderShipFirst": [
		30020,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3526,
			3743,
			1326,
			528,
			8498,
			3133,
			20
		]
	],
	"./Lite/OrderManagement/OrderShipFirst.js": [
		30020,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3526,
			3743,
			1326,
			528,
			8498,
			3133,
			20
		]
	],
	"./Lite/OrderMessage/OrderMessageFirst": [
		37979,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			528,
			8498,
			8793,
			8844,
			1002
		]
	],
	"./Lite/OrderMessage/OrderMessageFirst.js": [
		37979,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			528,
			8498,
			8793,
			8844,
			1002
		]
	],
	"./Lite/PromotionSetting/PromoAllFirst": [
		8812,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2315,
			1200,
			6502,
			528,
			8498,
			3968,
			6801,
			1178,
			8812
		]
	],
	"./Lite/PromotionSetting/PromoAllFirst.js": [
		8812,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2315,
			1200,
			6502,
			528,
			8498,
			3968,
			6801,
			1178,
			8812
		]
	],
	"./Lite/PromotionSetting/PromotionAllSecond": [
		42282,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1200,
			6502,
			5854,
			528,
			8498,
			3968,
			6801,
			8147,
			4974,
			2282
		]
	],
	"./Lite/PromotionSetting/PromotionAllSecond.js": [
		42282,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1200,
			6502,
			5854,
			528,
			8498,
			3968,
			6801,
			8147,
			4974,
			2282
		]
	],
	"./Lite/Report/CustomerReport": [
		16239,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			7072,
			6239
		]
	],
	"./Lite/Report/CustomerReport.js": [
		16239,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			7072,
			6239
		]
	],
	"./Lite/Report/OrderSaleSummary": [
		18252,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7255
		]
	],
	"./Lite/Report/OrderSaleSummary.js": [
		18252,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7255
		]
	],
	"./Lite/Report/StockReport": [
		83913,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564,
			3913
		]
	],
	"./Lite/Report/StockReport.js": [
		83913,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564,
			3913
		]
	],
	"./Lite/SellSetting/SellSettingFirst": [
		39331,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			7206,
			9331
		]
	],
	"./Lite/SellSetting/SellSettingFirst.js": [
		39331,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			7206,
			9331
		]
	],
	"./Lite/SellSetting/SellSettingSecond": [
		75269,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			1200,
			1184,
			528,
			8498,
			3968,
			5386,
			5269
		]
	],
	"./Lite/SellSetting/SellSettingSecond.js": [
		75269,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			1200,
			1184,
			528,
			8498,
			3968,
			5386,
			5269
		]
	],
	"./Stock/Commodity/CommodityListFirst": [
		28109,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2173,
			528,
			8498,
			3968,
			6801,
			8109
		]
	],
	"./Stock/Commodity/CommodityListFirst.js": [
		28109,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2173,
			528,
			8498,
			3968,
			6801,
			8109
		]
	],
	"./Stock/Commodity/CommodityListSecond": [
		35959,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			3743,
			1200,
			9109,
			528,
			8498,
			5959
		]
	],
	"./Stock/Commodity/CommodityListSecond.js": [
		35959,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			3743,
			1200,
			9109,
			528,
			8498,
			5959
		]
	],
	"./Stock/Commodity/CommoditySortFirst": [
		74273,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			7672,
			5485,
			9305,
			528,
			8498,
			4273
		]
	],
	"./Stock/Commodity/CommoditySortFirst.js": [
		74273,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			8851,
			7692,
			8710,
			4508,
			216,
			7672,
			5485,
			9305,
			528,
			8498,
			4273
		]
	],
	"./Stock/Commodity/CommoditySortSecond": [
		44003,
		7,
		[
			4003
		]
	],
	"./Stock/Commodity/CommoditySortSecond.js": [
		44003,
		7,
		[
			4003
		]
	],
	"./Stock/Commodity/CommoditySortThird": [
		43402,
		7,
		[
			3402
		]
	],
	"./Stock/Commodity/CommoditySortThird.js": [
		43402,
		7,
		[
			3402
		]
	],
	"./Stock/Commodity/StockPutInFirst": [
		50340,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			528,
			8498,
			340
		]
	],
	"./Stock/Commodity/StockPutInFirst.js": [
		50340,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			528,
			8498,
			340
		]
	],
	"./Stock/Commodity/StockPutInSecond": [
		30196,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			196
		]
	],
	"./Stock/Commodity/StockPutInSecond.js": [
		30196,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			196
		]
	],
	"./Stock/Company/CompanyFirst": [
		44633,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			4633
		]
	],
	"./Stock/Company/CompanyFirst.js": [
		44633,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			4633
		]
	],
	"./Stock/Company/CompanySecond": [
		60283,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			283
		]
	],
	"./Stock/Company/CompanySecond.js": [
		60283,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			283
		]
	],
	"./Stock/Import/ImportListFirst": [
		16953,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			2315,
			7672,
			5485,
			466,
			528,
			8498,
			6953
		]
	],
	"./Stock/Import/ImportListFirst.js": [
		16953,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			2315,
			7672,
			5485,
			466,
			528,
			8498,
			6953
		]
	],
	"./Stock/Import/ImportListSecond": [
		44699,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			4699
		]
	],
	"./Stock/Import/ImportListSecond.js": [
		44699,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			4699
		]
	],
	"./Stock/Index/Home": [
		69136,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			9136
		]
	],
	"./Stock/Index/Home.js": [
		69136,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			6607,
			2351,
			637,
			8851,
			7692,
			528,
			8498,
			9136
		]
	],
	"./Stock/InventoryControl/InvAdjustFirst": [
		98728,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			8728
		]
	],
	"./Stock/InventoryControl/InvAdjustFirst.js": [
		98728,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			8728
		]
	],
	"./Stock/InventoryControl/InvAdjustSecond": [
		7956,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			7956
		]
	],
	"./Stock/InventoryControl/InvAdjustSecond.js": [
		7956,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			7956
		]
	],
	"./Stock/InventoryControl/InvScrapFirst": [
		60890,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			890
		]
	],
	"./Stock/InventoryControl/InvScrapFirst.js": [
		60890,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			890
		]
	],
	"./Stock/InventoryControl/InvScrapSecond": [
		39643,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			9683,
			9643
		]
	],
	"./Stock/InventoryControl/InvScrapSecond.js": [
		39643,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			9683,
			9643
		]
	],
	"./Stock/InventoryControl/InvTransferFirst": [
		81796,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			1796
		]
	],
	"./Stock/InventoryControl/InvTransferFirst.js": [
		81796,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			1796
		]
	],
	"./Stock/InventoryControl/InvTransferSecond": [
		60688,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			688
		]
	],
	"./Stock/InventoryControl/InvTransferSecond.js": [
		60688,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			9683,
			688
		]
	],
	"./Stock/Purchase/PurchaseListFirst": [
		46790,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6790
		]
	],
	"./Stock/Purchase/PurchaseListFirst.js": [
		46790,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6790
		]
	],
	"./Stock/Purchase/PurchaseListSecond": [
		19227,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			581,
			528,
			8498,
			9227
		]
	],
	"./Stock/Purchase/PurchaseListSecond.js": [
		19227,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			2425,
			581,
			528,
			8498,
			9227
		]
	],
	"./Stock/Stock/StockListFirst": [
		25561,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5561
		]
	],
	"./Stock/Stock/StockListFirst.js": [
		25561,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5561
		]
	],
	"./Stock/Stock/StockListSecond": [
		86651,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6801,
			172
		]
	],
	"./Stock/Stock/StockListSecond.js": [
		86651,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			6801,
			172
		]
	],
	"./Stock/StockReport/StockReport": [
		12671,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564,
			2671
		]
	],
	"./Stock/StockReport/StockReport.js": [
		12671,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564,
			2671
		]
	],
	"./Stock/Warehouse/WarehouseFirst": [
		24409,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			4409
		]
	],
	"./Stock/Warehouse/WarehouseFirst.js": [
		24409,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			528,
			8498,
			3968,
			4409
		]
	],
	"./Stock/Warehouse/WarehouseSecond": [
		31451,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			1451
		]
	],
	"./Stock/Warehouse/WarehouseSecond.js": [
		31451,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			1451
		]
	],
	"./WebContent/CustomerManagement/BonusImportLog": [
		90253,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			253
		]
	],
	"./WebContent/CustomerManagement/BonusImportLog.js": [
		90253,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			253
		]
	],
	"./WebContent/CustomerManagement/CustomerFirst": [
		13555,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			3394
		]
	],
	"./WebContent/CustomerManagement/CustomerFirst.js": [
		13555,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			528,
			8498,
			3394
		]
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst": [
		77061,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			2991,
			528,
			8498,
			7061
		]
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst.js": [
		77061,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			3743,
			2991,
			528,
			8498,
			7061
		]
	],
	"./WebContent/CustomerManagement/CustomerSecond": [
		15093,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			5093
		]
	],
	"./WebContent/CustomerManagement/CustomerSecond.js": [
		15093,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			5093
		]
	],
	"./WebContent/Index/Home": [
		36327,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2062,
			528,
			8498,
			3968,
			6801,
			7763
		]
	],
	"./WebContent/Index/Home.js": [
		36327,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			2062,
			528,
			8498,
			3968,
			6801,
			7763
		]
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail": [
		87994,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			6665
		]
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail.js": [
		87994,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			6665
		]
	],
	"./WebContent/LogisticsSetting/LogisticsFirst": [
		84508,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			2127
		]
	],
	"./WebContent/LogisticsSetting/LogisticsFirst.js": [
		84508,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			2127
		]
	],
	"./WebContent/LogisticsSetting/LogisticsSecond": [
		91728,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			627,
			528,
			8498,
			1728
		]
	],
	"./WebContent/LogisticsSetting/LogisticsSecond.js": [
		91728,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3743,
			627,
			528,
			8498,
			1728
		]
	],
	"./WebContent/MailManagement/MailTempList": [
		98841,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			8841
		]
	],
	"./WebContent/MailManagement/MailTempList.tsx": [
		98841,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			8841
		]
	],
	"./WebContent/MailManagement/components/HistoryList": [
		65950,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			5950
		]
	],
	"./WebContent/MailManagement/components/HistoryList.tsx": [
		65950,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			5950
		]
	],
	"./WebContent/MailManagement/components/ReviewMail": [
		2449,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			2449
		]
	],
	"./WebContent/MailManagement/components/ReviewMail.tsx": [
		2449,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			2449
		]
	],
	"./WebContent/MailManagement/components/RichTextEditor": [
		41751,
		9,
		[
			3301,
			7489
		]
	],
	"./WebContent/MailManagement/components/RichTextEditor.tsx": [
		41751,
		9,
		[
			3301,
			7489
		]
	],
	"./WebContent/MailManagement/components/TemplateDialogs": [
		91570,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8511,
			6403,
			1570,
			9760
		]
	],
	"./WebContent/MailManagement/components/TemplateDialogs.tsx": [
		91570,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8511,
			6403,
			1570,
			9760
		]
	],
	"./WebContent/MailManagement/components/TemplateList": [
		18593,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			8593
		]
	],
	"./WebContent/MailManagement/components/TemplateList.tsx": [
		18593,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			8593
		]
	],
	"./WebContent/MailManagement/components/WriteMail": [
		87824,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			7824
		]
	],
	"./WebContent/MailManagement/components/WriteMail.tsx": [
		87824,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			8987,
			528,
			8498,
			8511,
			6403,
			1570,
			7824
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogAdd": [
		1732,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			6428
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogAdd.tsx": [
		1732,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			6428
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogEdit": [
		5865,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			528,
			579
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogEdit.tsx": [
		5865,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			528,
			579
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogHistory": [
		70885,
		9,
		[
			8591,
			216,
			528,
			5292
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogHistory.tsx": [
		70885,
		9,
		[
			8591,
			216,
			528,
			5292
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogReview": [
		40741,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			216,
			528,
			741
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogReview.tsx": [
		40741,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			216,
			528,
			741
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogSend": [
		59271,
		7,
		[
			9271
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogSend.tsx": [
		59271,
		7,
		[
			9271
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogWrite": [
		33016,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			528,
			8511,
			6403,
			4479
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogWrite.tsx": [
		33016,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			528,
			8511,
			6403,
			4479
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogWriteUpdate": [
		11539,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			528,
			8511,
			6403,
			7260
		]
	],
	"./WebContent/MailManagement/components/dialogs/DialogWriteUpdate.tsx": [
		11539,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			3301,
			2315,
			59,
			528,
			8511,
			6403,
			7260
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/EditContent": [
		76835,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			45
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/EditContent.tsx": [
		76835,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			3301,
			45
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/SelectCustomer": [
		96403,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			59,
			528,
			8511,
			6403,
			8452
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/SelectCustomer.tsx": [
		96403,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			6886,
			637,
			216,
			3526,
			5836,
			4286,
			3743,
			59,
			528,
			8511,
			6403,
			8452
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/SelectTemplate": [
		39344,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			637,
			528,
			8511,
			6370
		]
	],
	"./WebContent/MailManagement/components/dialogs/send-steps/SelectTemplate.tsx": [
		39344,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			637,
			528,
			8511,
			6370
		]
	],
	"./WebContent/MailManagement/hooks": [
		78511,
		9,
		[
			528,
			8511,
			2426
		]
	],
	"./WebContent/MailManagement/hooks/": [
		78511,
		9,
		[
			528,
			8511,
			2426
		]
	],
	"./WebContent/MailManagement/hooks/index": [
		78511,
		9,
		[
			528,
			8511,
			2426
		]
	],
	"./WebContent/MailManagement/hooks/index.ts": [
		78511,
		9,
		[
			528,
			8511,
			2426
		]
	],
	"./WebContent/MailManagement/hooks/useCustomers": [
		13623,
		9,
		[
			528,
			3623
		]
	],
	"./WebContent/MailManagement/hooks/useCustomers.ts": [
		13623,
		9,
		[
			528,
			3623
		]
	],
	"./WebContent/MailManagement/hooks/useDialog": [
		47328,
		9,
		[
			7328
		]
	],
	"./WebContent/MailManagement/hooks/useDialog.ts": [
		47328,
		9,
		[
			7328
		]
	],
	"./WebContent/MailManagement/hooks/useMailHistory": [
		91183,
		9,
		[
			528,
			1183
		]
	],
	"./WebContent/MailManagement/hooks/useMailHistory.ts": [
		91183,
		9,
		[
			528,
			1183
		]
	],
	"./WebContent/MailManagement/hooks/useMailTemplates": [
		32176,
		9,
		[
			528,
			2176
		]
	],
	"./WebContent/MailManagement/hooks/useMailTemplates.ts": [
		32176,
		9,
		[
			528,
			2176
		]
	],
	"./WebContent/MailManagement/hooks/useReviewMail": [
		13683,
		9,
		[
			528,
			3683
		]
	],
	"./WebContent/MailManagement/hooks/useReviewMail.ts": [
		13683,
		9,
		[
			528,
			3683
		]
	],
	"./WebContent/MailManagement/hooks/useWriteMail": [
		88666,
		9,
		[
			528,
			8666
		]
	],
	"./WebContent/MailManagement/hooks/useWriteMail.ts": [
		88666,
		9,
		[
			528,
			8666
		]
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst": [
		75200,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			7672,
			5485,
			5162,
			528,
			8498,
			3968,
			6801,
			5200
		]
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst.js": [
		75200,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			7672,
			5485,
			5162,
			528,
			8498,
			3968,
			6801,
			5200
		]
	],
	"./WebContent/OrderManagement/OrderFirst": [
		5932,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2315,
			2425,
			1200,
			7672,
			5485,
			528,
			8498,
			3968,
			5932
		]
	],
	"./WebContent/OrderManagement/OrderFirst.js": [
		5932,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2315,
			2425,
			1200,
			7672,
			5485,
			528,
			8498,
			3968,
			5932
		]
	],
	"./WebContent/OrderManagement/OrderPickingFirst": [
		33222,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7041,
			528,
			8498,
			3968,
			3222
		]
	],
	"./WebContent/OrderManagement/OrderPickingFirst.js": [
		33222,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1861,
			2425,
			7041,
			528,
			8498,
			3968,
			3222
		]
	],
	"./WebContent/OrderManagement/OrderReturnFirst": [
		79281,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			3134
		]
	],
	"./WebContent/OrderManagement/OrderReturnFirst.js": [
		79281,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			3134
		]
	],
	"./WebContent/OrderManagement/OrderReturnSecond": [
		32755,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			2755
		]
	],
	"./WebContent/OrderManagement/OrderReturnSecond.js": [
		32755,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			528,
			8498,
			3968,
			2755
		]
	],
	"./WebContent/OrderManagement/OrderSecond": [
		90909,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			1200,
			528,
			8498,
			3968,
			909
		]
	],
	"./WebContent/OrderManagement/OrderSecond.js": [
		90909,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			8619,
			1861,
			2425,
			1200,
			528,
			8498,
			3968,
			909
		]
	],
	"./WebContent/OrderManagement/OrderShipFirst": [
		93133,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3526,
			3743,
			1326,
			528,
			8498,
			3133
		]
	],
	"./WebContent/OrderManagement/OrderShipFirst.js": [
		93133,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			3526,
			3743,
			1326,
			528,
			8498,
			3133
		]
	],
	"./WebContent/OrderMessage/OrderMessageFirst": [
		34239,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			528,
			8498,
			8793,
			8844,
			4686
		]
	],
	"./WebContent/OrderMessage/OrderMessageFirst.js": [
		34239,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			1861,
			528,
			8498,
			8793,
			8844,
			4686
		]
	],
	"./WebContent/PaymentSetting/PaymentFirst": [
		86262,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			6262
		]
	],
	"./WebContent/PaymentSetting/PaymentFirst.js": [
		86262,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			528,
			8498,
			3968,
			6262
		]
	],
	"./WebContent/PromotionSetting/PromoAllFirst": [
		43861,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2315,
			1200,
			6502,
			528,
			8498,
			3968,
			6801,
			1178
		]
	],
	"./WebContent/PromotionSetting/PromoAllFirst.js": [
		43861,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			2315,
			1200,
			6502,
			528,
			8498,
			3968,
			6801,
			1178
		]
	],
	"./WebContent/PromotionSetting/PromoDIY": [
		41090,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			6886,
			637,
			8851,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			1200,
			6502,
			5854,
			8104,
			528,
			6801,
			8147,
			1090
		]
	],
	"./WebContent/PromotionSetting/PromoDIY.tsx": [
		41090,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			6886,
			637,
			8851,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			3743,
			1200,
			6502,
			5854,
			8104,
			528,
			6801,
			8147,
			1090
		]
	],
	"./WebContent/PromotionSetting/PromotionAllSecond": [
		34974,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1200,
			6502,
			5854,
			528,
			8498,
			3968,
			6801,
			8147,
			4974
		]
	],
	"./WebContent/PromotionSetting/PromotionAllSecond.js": [
		34974,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			1200,
			6502,
			5854,
			528,
			8498,
			3968,
			6801,
			8147,
			4974
		]
	],
	"./WebContent/Report/AdjustDetailReport": [
		74822,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7781
		]
	],
	"./WebContent/Report/AdjustDetailReport.js": [
		74822,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7781
		]
	],
	"./WebContent/Report/CustomerReport": [
		67072,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			7072
		]
	],
	"./WebContent/Report/CustomerReport.js": [
		67072,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			7072
		]
	],
	"./WebContent/Report/ImportScrapReport": [
		24032,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			4875
		]
	],
	"./WebContent/Report/ImportScrapReport.js": [
		24032,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			4875
		]
	],
	"./WebContent/Report/OrderRevenue": [
		35274,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			1625
		]
	],
	"./WebContent/Report/OrderRevenue.js": [
		35274,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			1625
		]
	],
	"./WebContent/Report/OrderSaleDetail": [
		21034,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			8889
		]
	],
	"./WebContent/Report/OrderSaleDetail.js": [
		21034,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			8889
		]
	],
	"./WebContent/Report/OrderSaleSummary": [
		30823,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7800
		]
	],
	"./WebContent/Report/OrderSaleSummary.js": [
		30823,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			7800
		]
	],
	"./WebContent/Report/PromotionReport": [
		83371,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			8028
		]
	],
	"./WebContent/Report/PromotionReport.js": [
		83371,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			8028
		]
	],
	"./WebContent/Report/ScrapDetailReport": [
		20554,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			1801
		]
	],
	"./WebContent/Report/ScrapDetailReport.js": [
		20554,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			1801
		]
	],
	"./WebContent/Report/StockReport": [
		85564,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564
		]
	],
	"./WebContent/Report/StockReport.js": [
		85564,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			5564
		]
	],
	"./WebContent/Report/StockTransferReport": [
		23815,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			72
		]
	],
	"./WebContent/Report/StockTransferReport.js": [
		23815,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			216,
			3526,
			5836,
			4286,
			4284,
			528,
			8498,
			6801,
			72
		]
	],
	"./WebContent/SellSetting/SellSettingFirst": [
		27206,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			7206
		]
	],
	"./WebContent/SellSetting/SellSettingFirst.js": [
		27206,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			637,
			8851,
			7692,
			8710,
			528,
			8498,
			7206
		]
	],
	"./WebContent/SellSetting/SellSettingSecond": [
		45386,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			1200,
			1184,
			528,
			8498,
			3968,
			5386
		]
	],
	"./WebContent/SellSetting/SellSettingSecond.js": [
		45386,
		9,
		[
			8049,
			7000,
			7434,
			8591,
			2788,
			6607,
			2351,
			6886,
			637,
			8851,
			7692,
			8710,
			4508,
			216,
			3526,
			5836,
			4286,
			4284,
			3743,
			8619,
			3301,
			1200,
			1184,
			528,
			8498,
			3968,
			5386
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[2].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, ids[1] | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12675;
module.exports = webpackAsyncContext;